var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"justify-center":""}},[_c('v-row',{staticClass:"justify-center"},[_vm._v("404: page Not found ¯\\_(ツ)_/¯")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }